import FabricComponent from './fabric.vue';

const Fabric = {
  install: function (Vue) {
    Vue.component(FabricComponent.name, FabricComponent);
  }
};
export default Fabric;
